var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import UtilsMixin from '@/mixins/utils-mixin';
import DatePicker from '@/components/shared/DatePicker.vue';
import { ContractManagementService } from '@/services/contract-management/contract-management-service';
import * as isEqual from 'date-fns/is_equal';
import * as isAfter from 'date-fns/is_after';
import * as isBefore from 'date-fns/is_before';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';
import * as uuid_v4 from 'uuid/v4';
var DefaultPricingFormulasCrudSidesheet = /** @class */ (function (_super) {
    __extends(DefaultPricingFormulasCrudSidesheet, _super);
    function DefaultPricingFormulasCrudSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.referenceDataLoaded = false;
        _this.options = {
            times: [],
        };
        _this.startDatePicker = false;
        _this.endDatePicker = false;
        return _this;
    }
    DefaultPricingFormulasCrudSidesheet.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.validationRules = this.contractManagementService.getValidationRules();
                this.referenceDataLoaded = false;
                return [2 /*return*/];
            });
        });
    };
    DefaultPricingFormulasCrudSidesheet.prototype.getReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // if we have already loaded the reference data, don't load again
                if (this.referenceDataLoaded) {
                    return [2 /*return*/];
                }
                this.options.times = this.contractManagementService.getHours();
                this.referenceDataLoaded = true;
                return [2 /*return*/];
            });
        });
    };
    DefaultPricingFormulasCrudSidesheet.prototype.creating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var defaultPricingFormula, contract, startDate_1, endDate_1, overlap, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        defaultPricingFormula = __assign({}, this.selectedItem);
                        contract = __assign({}, this.item);
                        defaultPricingFormula.contractDefaultPricingXrefId = this.getUniqueId();
                        startDate_1 = defaultPricingFormula.startDate;
                        endDate_1 = defaultPricingFormula.endDate;
                        overlap = contract.defaultPricingFormulas
                            .filter(function (dpf) {
                            return (_this.isDateAfterOrEqual(startDate_1, dpf.startDate) && _this.isDateBefore(startDate_1, dpf.endDate)) ||
                                (_this.isDateBeforeOrEqual(endDate_1, dpf.endDate) && _this.isDateAfter(endDate_1, dpf.startDate)) ||
                                (_this.isDateBeforeOrEqual(startDate_1, dpf.startDate) && _this.isDateAfterOrEqual(endDate_1, dpf.endDate));
                        });
                        if (!(overlap.length > 0)) return [3 /*break*/, 1];
                        // show an error to the user, and do not update local collection
                        this.showSnackbar({
                            text: 'The time period overlaps with an existing default pricing formula',
                            color: 'error',
                        });
                        return [3 /*break*/, 3];
                    case 1: 
                    // update local collection
                    return [4 /*yield*/, this.updateItems(defaultPricingFormula)];
                    case 2:
                        // update local collection
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to save default pricing formula',
                            color: 'error',
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DefaultPricingFormulasCrudSidesheet.prototype.updateItems = function (item) {
        if (item === void 0) { item = null; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, startDate_2, endDate_2, overlap;
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    if (item === null) {
                        item = __assign({}, this.selectedItem);
                    }
                    contract = __assign({}, this.item);
                    startDate_2 = item.startDate;
                    endDate_2 = item.endDate;
                    overlap = contract.defaultPricingFormulas
                        .filter(function (dpf) {
                        return (_this.isDateAfterOrEqual(startDate_2, dpf.startDate) && _this.isDateBefore(startDate_2, dpf.endDate) && item.contractDefaultPricingXrefId !== dpf.contractDefaultPricingXrefId) ||
                            (_this.isDateBeforeOrEqual(endDate_2, dpf.endDate) && _this.isDateAfter(endDate_2, dpf.startDate) && item.contractDefaultPricingXrefId !== dpf.contractDefaultPricingXrefId) ||
                            (_this.isDateBeforeOrEqual(startDate_2, dpf.startDate) && _this.isDateAfterOrEqual(endDate_2, dpf.endDate) && item.contractDefaultPricingXrefId !== dpf.contractDefaultPricingXrefId);
                    });
                    if (overlap.length > 0) {
                        // show an error to the user, and do not update local collection
                        this.showSnackbar({
                            text: 'The time period overlaps with an existing default pricing formula',
                            color: 'error',
                        });
                    }
                    else {
                        // locally update collection
                        contract.defaultPricingFormulas = this.updateItemsCollection(contract.defaultPricingFormulas, item, ['contractDefaultPricingXrefId', 'contractId']);
                        // update item we are looking at
                        this.item = contract;
                        // close the side sheetja
                        this.close();
                        this.showSnackbar({
                            text: 'Default pricing formula has been saved locally.<br />You must SUBMIT the contract in order for your changes to take affect.',
                            color: 'success',
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                    this.showSnackbar({
                        text: 'Unable to save default pricing formula',
                        color: 'error',
                    });
                }
                finally {
                    this.sidesheetLoading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "formattedStartDate", {
        get: function () {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.startDate) {
                return defaultPricingFormula.startDate !== ''
                    ? format(defaultPricingFormula.startDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && newValue && newValue.length === 10) {
                defaultPricingFormula.startDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.selectedItem = defaultPricingFormula;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "contractStartTime", {
        get: function () {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.startDate) {
                return defaultPricingFormula.startDate !== ''
                    ? this.formatTime(defaultPricingFormula.startDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.startDate) {
                var currentStartTime = this.formatTime(defaultPricingFormula.startDate);
                if (currentStartTime !== newValue) {
                    defaultPricingFormula.startDate = format(defaultPricingFormula.startDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.selectedItem = defaultPricingFormula;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "formattedEndDate", {
        get: function () {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.endDate) {
                return defaultPricingFormula.endDate !== ''
                    ? format(defaultPricingFormula.endDate, 'MM/DD/YYYY')
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && newValue && newValue.length === 10) {
                defaultPricingFormula.endDate = format(new Date(newValue), 'YYYY-MM-DD');
                this.selectedItem = defaultPricingFormula;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "contractEndTime", {
        get: function () {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.endDate) {
                return defaultPricingFormula.endDate !== ''
                    ? this.formatTime(defaultPricingFormula.endDate)
                    : '';
            }
            else {
                return '';
            }
        },
        set: function (newValue) {
            var defaultPricingFormula = __assign({}, this.selectedItem);
            if (defaultPricingFormula && defaultPricingFormula.endDate) {
                var currentEndTime = this.formatTime(defaultPricingFormula.endDate);
                if (currentEndTime !== newValue) {
                    defaultPricingFormula.endDate = format(defaultPricingFormula.endDate, 'YYYY-MM-DD') + ' ' + newValue;
                    this.selectedItem = defaultPricingFormula;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    DefaultPricingFormulasCrudSidesheet.prototype.formatTime = function (date) {
        return format(date, 'HH:mm');
    };
    DefaultPricingFormulasCrudSidesheet.prototype.isDateBefore = function (date, otherDate) {
        return !otherDate || isBefore(parse(date), parse(otherDate));
    };
    DefaultPricingFormulasCrudSidesheet.prototype.isDateAfter = function (date, otherDate) {
        return !otherDate || isAfter(parse(date), parse(otherDate));
    };
    DefaultPricingFormulasCrudSidesheet.prototype.isDateBeforeOrEqual = function (date, otherDate) {
        return !otherDate || isEqual(parse(date), parse(otherDate)) || isBefore(parse(date), parse(otherDate));
    };
    DefaultPricingFormulasCrudSidesheet.prototype.isDateAfterOrEqual = function (date, otherDate) {
        return !otherDate || isEqual(parse(date), parse(otherDate)) || isAfter(parse(date), parse(otherDate));
    };
    DefaultPricingFormulasCrudSidesheet.prototype.getUniqueId = function () {
        return uuid_v4();
    };
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "startDateValidationRule", {
        get: function () {
            return this.visible ? { required: true, date_format: 'MM/dd/yyyy' } : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "endDateValidationRule", {
        get: function () {
            return this.visible ? { required: true, date_format: 'MM/dd/yyyy' } : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultPricingFormulasCrudSidesheet.prototype, "formulaValidationRule", {
        get: function () {
            return this.visible ? { required: true } : {};
        },
        enumerable: false,
        configurable: true
    });
    DefaultPricingFormulasCrudSidesheet.prototype.onStepChanged = function (val, oldVal) {
        if (val && val !== oldVal && val === 'DPF') {
            this.getReferenceData();
        }
    };
    var _a;
    __decorate([
        lazyInject(TYPES.ContractManagementService),
        __metadata("design:type", typeof (_a = typeof ContractManagementService !== "undefined" && ContractManagementService) === "function" ? _a : Object)
    ], DefaultPricingFormulasCrudSidesheet.prototype, "contractManagementService", void 0);
    __decorate([
        Watch('step', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DefaultPricingFormulasCrudSidesheet.prototype, "onStepChanged", null);
    DefaultPricingFormulasCrudSidesheet = __decorate([
        Component({
            components: {
                'base-crud-sidesheet': BaseCrudSidesheet,
                'date-picker': DatePicker,
            },
        })
    ], DefaultPricingFormulasCrudSidesheet);
    return DefaultPricingFormulasCrudSidesheet;
}(Mixins(CrudSidesheetMixin, SteppedPageMixin, SnackbarMixin, UtilsMixin)));
export default DefaultPricingFormulasCrudSidesheet;
